export const apiFormat = {
  yearMonth: 'YYYY-MM',
  yearMonthDay: 'YYYY-MM-DD',
  iso: 'YYYY-MM-DD[T]HH:mm:ssZ',
  isoSearch: 'YYYY-MM-DD[T]HH:mm:ss',
  time: 'HH:mm',
  timeWithSecs: 'HH:mm:ss',
  dayMonthYear: 'DD-MM-YYYY',
  isoRegex: /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}/
}
